/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasHeader } from '../../models/OasHeader';
import { Oas20Items } from './Oas20Items';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends OasHeader
 * @author eric.wittmann@gmail.com
 */
export class Oas20Header extends OasHeader {
    public type : string;

    public format : string;

    public items : Oas20Items;

    public collectionFormat : string;

    public default_ : any;

    public maximum : number;

    public exclusiveMaximum : boolean;

    public minimum : number;

    public exclusiveMinimum : boolean;

    public maxLength : number;

    public minLength : number;

    public pattern : string;

    public maxItems : number;

    public minItems : number;

    public uniqueItems : boolean;

    public enum_ : Array<string>;

    public multipleOf : number;

    public constructor(name : string) {
        super(name);
        if(this.type===undefined) this.type = null;
        if(this.format===undefined) this.format = null;
        if(this.items===undefined) this.items = null;
        if(this.collectionFormat===undefined) this.collectionFormat = null;
        if(this.default_===undefined) this.default_ = null;
        if(this.maximum===undefined) this.maximum = null;
        if(this.exclusiveMaximum===undefined) this.exclusiveMaximum = null;
        if(this.minimum===undefined) this.minimum = null;
        if(this.exclusiveMinimum===undefined) this.exclusiveMinimum = null;
        if(this.maxLength===undefined) this.maxLength = null;
        if(this.minLength===undefined) this.minLength = null;
        if(this.pattern===undefined) this.pattern = null;
        if(this.maxItems===undefined) this.maxItems = null;
        if(this.minItems===undefined) this.minItems = null;
        if(this.uniqueItems===undefined) this.uniqueItems = null;
        if(this.enum_===undefined) this.enum_ = null;
        if(this.multipleOf===undefined) this.multipleOf = null;
    }

    /**
     * Creates an items.
     * @return {Oas20Items}
     */
    public createItems() : Oas20Items {
        let rval : Oas20Items = new Oas20Items();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this._parent;
        return rval;
    }
}
Oas20Header["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Header";
Oas20Header["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




